interface IDIVIDEND_FORMULA {
  annualDividend: number | undefined;
  currentMarketPrice: number | undefined;
}

type DIVIDEND_RESPONSE = { dividendYeild: number };

export const DIVIDEND_CALCULATOR_FORMULA = ({
  annualDividend,
  currentMarketPrice,
}: IDIVIDEND_FORMULA): DIVIDEND_RESPONSE => {
  if (
    !annualDividend ||
    !currentMarketPrice ||
    Number(annualDividend) < 0 ||
    Number(currentMarketPrice) < 0
  ) {
    return {
      dividendYeild: 0,
    };
  }

  return {
    dividendYeild: (annualDividend / currentMarketPrice) * 100,
  };
};
